// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pr-0";
export var leftAlign = "_pr-4";
export var listItem = "_pr-2";
export var listItemWrapper = "_pr-1";
export var operationText = "_pr-3";